import clsx from 'clsx';
import React from 'react';
import { prepareData } from 'utils/googleData';

export default function SimpleUse(props) {
  const {
    enable,
    title,
    cards,
  } = prepareData({ props });

  if (enable?.toLowerCase?.() === 'false' && !process.env.RENDER_DISABLED_COMPONENTS) {
    return <></>;
  }

  return (
    <section className="safe-paddings bg-[#0B1C39] py-24 md:py-20 sm:py-16">
      <div className="container">
        <h2 className="text-center text-3xl font-semibold text-white mb-16 md:mb-12 sm:mb-10">
          {title}
        </h2>

        <div className="flex justify-center">
          <div className="flex items-center space-x-24 lg:space-x-16 md:space-x-12 sm:space-x-8">
            {cards?.length > 0 && cards.map(({ Icon, title }, index) => (
              <div
                key={index}
                className="flex flex-col items-center"
              >
                {Icon && (
                  <div className="flex h-16 w-auto items-center justify-center">
                    <Icon className="h-12 w-auto opacity-80 transition-opacity duration-200 hover:opacity-100" />
                  </div>
                )}
                <p className="mt-4 text-center text-base text-white/80">
                  {title}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
